// frontend/src/pages/NotFoundCarousel.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  Container,
  Fade } from
'@mui/material';
import {
  SentimentVeryDissatisfied as SadIcon,
  Home as HomeIcon,
  Refresh as RefreshIcon } from
'@mui/icons-material';import { useThemeSettings } from "../contexts/ThemeContext";

const NotFound = () => {const { t } = useThemeSettings();
  const navigate = useNavigate();
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const funMessages = [
  "Oops! This page took a wrong turn at the internet. 🗺️",
  "404: Page not found. But you found this cool error page! 🎉",
  "This page is lost in the digital void. 🌌",
  "The page you're looking for is in another castle. 🏰",
  "Houston, we have a 404 problem. 🚀",
  "This page went on vacation and forgot to leave a forwarding address. 🏖️",
  "Looks like this link is broken. Did you try turning it off and on again? 🔌",
  "This page is playing hide and seek. It's winning. 🙈",
  "Error 404: Page not found. But your sense of humor is intact! 😄",
  "This page must be social distancing. We can't find it anywhere. 😷"];


  useEffect(() => {
    const interval = setInterval(() => {
      handleNextMessage();
    }, 2500);
    return () => clearInterval(interval);
  }, [currentMessageIndex]);

  const handleNextMessage = () => {
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentMessageIndex((prev) => (prev + 1) % funMessages.length);
      setIsTransitioning(false);
    }, 300);
  };

  const handlePrevMessage = () => {
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentMessageIndex((prev) =>
      prev === 0 ? funMessages.length - 1 : prev - 1
      );
      setIsTransitioning(false);
    }, 300);
  };

  return (
    <Box
      className="page-transition-enter"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #9f416c 0%, #e2a63e 100%)',
        position: 'relative',
        overflow: 'hidden'
      }}>
      
     
      <Container maxWidth="md">
        <Box
          sx={{
            textAlign: 'center',
            color: 'white',
            position: 'relative',
            zIndex: 1
          }}>
          
          {/* 404 with animated sad face */}
          <Box
            sx={{
              display: 'inline-block',
              position: 'relative',
              mb: 4
            }}>
            
            <Typography
              variant="h1"
              sx={{
                fontSize: { xs: '8rem', md: '12rem' },
                fontWeight: 'bold',
                textShadow: '0 5px 15px rgba(0,0,0,0.3)',
                position: 'relative',
                display: 'inline-block'
              }}>
              
              4
              <SadIcon
                sx={{
                  fontSize: { xs: '6rem', md: '8rem' },
                  verticalAlign: 'middle',
                  animation: 'bounce 2s ease-in-out infinite',
                  '@keyframes bounce': {
                    '0%, 100%': { transform: 'translateY(0) rotate(0deg)' },
                    '25%': { transform: 'translateY(-20px) rotate(-5deg)' },
                    '50%': { transform: 'translateY(0) rotate(0deg)' },
                    '75%': { transform: 'translateY(-10px) rotate(5deg)' }
                  }
                }} />
              
              4
            </Typography>
          </Box>

          <Typography
            variant="h4"
            className="slide-down"
            sx={{
              mb: 2,
              textShadow: '0 2px 10px rgba(0,0,0,0.2)'
            }}>{t ? t("NotFound.page_not_found") : "Page Not Found"}


          </Typography>

          {/* Message Carousel */}
          <Box
            sx={{
              mb: 4,
              minHeight: '80px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 2,
              px: 2
            }}>
            

            <Box
              sx={{
                flex: 1,
                maxWidth: 600,
                position: 'relative',
                height: '60px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
              
              <Fade in={!isTransitioning} timeout={300}>
                <Typography
                  variant="h6"
                  sx={{
                    opacity: 0.9,
                    fontStyle: 'italic',
                    position: 'absolute',
                    width: '100%',
                    px: 2
                  }}>
                  
                  {funMessages[currentMessageIndex]}
                </Typography>
              </Fade>
            </Box>

          </Box>


          {/* Action buttons */}
          <Box
            sx={{
              display: 'flex',
              gap: 2,
              justifyContent: 'center',
              flexWrap: 'wrap',
              mb: 4
            }}>
            
            <Button
              variant="contained"
              size="large"
              startIcon={<HomeIcon />}
              onClick={() => navigate('/')}
              sx={{
                backgroundColor: 'white',
                color: '#9f416c',
                '&:hover': {
                  backgroundColor: '#e2a63e',
                  color: 'white',
                  transform: 'scale(1.05)'
                },
                px: 4,
                py: 1.5,
                transition: 'all 0.3s ease'
              }}>{t ? t("NotFound.back_home") : "Back to Home"}


            </Button>

            <Button
              variant="outlined"
              size="large"
              startIcon={<RefreshIcon />}
              onClick={() => window.location.reload()}
              sx={{
                borderColor: 'white',
                color: 'white',
                '&:hover': {
                  borderColor: 'white',
                  backgroundColor: 'rgba(255,255,255,0.1)',
                  transform: 'scale(1.05)'
                },
                px: 4,
                py: 1.5,
                transition: 'all 0.3s ease'
              }}>{t ? t("LocationManagement.try_again") : "Try Again"}


            </Button>
          </Box>

        </Box>
      </Container>
    </Box>);

};

export default NotFound;